<!-- Filter - Search - Form  -->
<div class="data-action-form">
  <div class="row justify-content-between align-items-end">
    <div>
      <h3 class="pl-3">Roles</h3>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-3">
      <div class="row mx-n2 align-items-end">
        <div class="col-12 col-sm-8 col-md-8 col-lg-6 px-2">
          <div class="search-box">
            <div class="form-group">
              <input
                type="text"
                name=""
                placeholder="Search"
                class="form-control"
                #search
                (keyup)="searchInTable(search.value, 'search')" />
              <a href="javascript:;" class="search"><i class="fas fa-search"></i></a>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-md-4 col-lg-6 px-2" *ngIf="userPermissions.roles_setting.edit">
          <div class="form-group">
            <a
              href="javascript:;"
              class="btn btn-primary btn-block"
              data-toggle="modal"
              data-target="#edit-permissions"
              (click)="editPermission()"
              >Add Role</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Filter - Search - Form  End-->
<div class="table-responsive" *ngIf="rolesData.length > 0">
  <table class="table role-data-table mt-0">
    <thead>
      <tr>
        <th>Name</th>
        <th>Created</th>
        <th>Created by</th>
        <th>Description</th>
        <th class="text-right">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of rolesData">
        <td>{{ item.role_name }}</td>
        <td>
          <!-- <span *ngIf="item.created_date != '0000-00-00 00:00:00'"> -->
          {{ item.created_date | date: 'M/d/yyyy' : 'UTC' }}
          <!-- </span> -->
        </td>
        <td>{{ item.created_by_name }}</td>
        <td>{{ item.description }}</td>
        <td class="text-right">
          <a
            *ngIf="userPermissions.roles_setting.view && userPermissions.roles_setting.edit"
            href="javascript:;"
            class="font-20 mr-2"
            data-toggle="modal"
            data-target="#edit-permissions"
            (click)="editPermission(item)"
            ><i class="far fa-pen"></i
          ></a>
          <a
            *ngIf="userPermissions.roles_setting.view && userPermissions.roles_setting.edit"
            href="javascript:void(0);"
            class="font-20"
            data-toggle="modal"
            data-target="#delete-role"
            title="Delete"
            (click)="setDeleteRoleId(item.id)">
            <i class="far fa-trash"></i
          ></a>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="modal fade" id="edit-permissions" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content pb-0">
      <form [formGroup]="permissionForm" (ngSubmit)="onSubmit(permissionForm)">
        <div class="modal-header bg-color">
          <h5 class="modal-title">{{ mode }} Role: {{ permissionForm.get('role_name').value }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body">
          <input type="hidden" name="id" formControlName="id" />

          <ul class="nav nav-tabs line-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <a class="nav-link active" data-toggle="tab" href="#general" role="tab" aria-selected="true">General</a>
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" data-toggle="tab" href="#jobs" role="tab" aria-selected="false">Jobs</a>
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" data-toggle="tab" href="#tool-pointe" role="tab" aria-selected="false">ToolPointe</a>
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" data-toggle="tab" href="#job-pointe" role="tab" aria-selected="false">JobPointe</a>
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" data-toggle="tab" href="#purchase-orders" role="tab" aria-selected="false"
                >PurchasePointe</a
              >
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link" data-toggle="tab" href="#settings" role="tab" aria-selected="false">Settings</a>
            </li>
          </ul>
          <div class="tab-content">
            <!-- General -->
            <div class="tab-pane fade show active" id="general" role="tabpanel">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-4 col-lg-6">
                  <div class="form-group">
                    <label>Role Name</label>
                    <input type="text" class="form-control" name="role_name" formControlName="role_name" />
                    <span
                      class="error"
                      *ngIf="
                        permissionForm.get('role_name').hasError('required') && permissionForm.get('role_name').touched
                      ">
                      Please provide name
                    </span>
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-6">
                  <div class="form-group">
                    <label>Description</label>
                    <input type="text" class="form-control" name="description" formControlName="description" />
                    <span
                      class="error"
                      *ngIf="
                        permissionForm.get('description').hasError('required') &&
                        permissionForm.get('description').touched
                      ">
                      Please provide description
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Jobs -->
            <div class="tab-pane fade" id="jobs" role="tabpanel" formGroupName="permissions">
              <table class="texupp" width="100%">
                <tbody>
                  <tr>
                    <td></td>
                    <th>View</th>
                    <th>Edit</th>
                  </tr>
                  <tr class="permissions_form" formGroupName="main_job_list">
                    <td>
                      <span class="text-black">Main Job List</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input p_view"
                          id="customCheck1"
                          formControlName="view"
                          (change)="setValue($event, 'main_job_list', 'view')" />
                        <label class="custom-control-label" for="customCheck1"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input p_edit"
                          id="customCheck2"
                          formControlName="edit"
                          (change)="setValue($event, 'main_job_list', 'edit')" />
                        <label class="custom-control-label" for="customCheck2"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="general_info">
                    <td>
                      <span class="text-black pl-3">General Info</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck3"
                          formControlName="view"
                          (change)="setValue($event, 'general_info', 'view')" />
                        <label class="custom-control-label" for="customCheck3"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck4"
                          formControlName="edit"
                          (change)="setValue($event, 'general_info', 'edit')" />
                        <label class="custom-control-label" for="customCheck4"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="billing_accounting">
                    <td>
                      <span class="text-black pl-3">Billing & Accounting</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck5"
                          formControlName="view"
                          (change)="setValue($event, 'billing_accounting', 'view')" />
                        <label class="custom-control-label" for="customCheck5"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck6"
                          formControlName="edit"
                          (change)="setValue($event, 'billing_accounting', 'edit')" />
                        <label class="custom-control-label" for="customCheck6"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="financials">
                    <td>
                      <span class="text-black pl-3">Financials</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck7"
                          formControlName="view"
                          (change)="setValue($event, 'financials', 'view')" />
                        <label class="custom-control-label" for="customCheck7"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck8"
                          formControlName="edit"
                          (change)="setValue($event, 'financials', 'edit')" />
                        <label class="custom-control-label" for="customCheck8"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="audit_trail">
                    <td>
                      <span class="text-black pl-3">Audit Trail</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck11"
                          formControlName="view"
                          (change)="setValue($event, 'audit_trail', 'view')" />
                        <label class="custom-control-label" for="customCheck11"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck12"
                          formControlName="edit"
                          (change)="setValue($event, 'audit_trail', 'edit')" />
                        <label class="custom-control-label" for="customCheck12"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="locked_fields">
                    <td>
                      <span class="text-black pl-3">Locked Fields</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck13"
                          formControlName="view"
                          (change)="setValue($event, 'locked_fields', 'view')" />
                        <label class="custom-control-label" for="customCheck13"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck14"
                          formControlName="edit"
                          (change)="setValue($event, 'locked_fields', 'edit')" />
                        <label class="custom-control-label" for="customCheck14"></label>
                      </div>
                    </td>
                  </tr>

                  <tr class="permissions_form" formGroupName="working_status">
                    <td>
                      <span class="text-black pl-3">Working Status</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck88"
                          formControlName="view"
                          (change)="setValue($event, 'working_status', 'view')" />
                        <label class="custom-control-label" for="customCheck88"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck89"
                          formControlName="edit"
                          (change)="setValue($event, 'working_status', 'edit')" />
                        <label class="custom-control-label" for="customCheck89"></label>
                      </div>
                    </td>
                  </tr>

                  <tr class="permissions_form" formGroupName="invoicing_list">
                    <td>
                      <span class="text-black">Invoicing</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck15"
                          formControlName="view"
                          (change)="setValue($event, 'invoicing_list', 'view')" />
                        <label class="custom-control-label" for="customCheck15"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck16"
                          formControlName="edit"
                          (change)="setValue($event, 'invoicing_list', 'edit')" />
                        <label class="custom-control-label" for="customCheck16"></label>
                      </div>
                    </td>
                  </tr>

                  <tr class="permissions_form" formGroupName="invoicing_reset">
                    <td>
                      <span class="text-black">Invoicing Reset</span>
                    </td>
                    <td></td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck31"
                          formControlName="edit"
                          (change)="setValue($event, 'invoicing_reset', 'edit')" />
                        <label class="custom-control-label" for="customCheck31"></label>
                      </div>
                    </td>
                  </tr>

                  <tr class="permissions_form" formGroupName="job_status">
                    <td>
                      <span class="text-black">Job Status</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck19"
                          formControlName="view"
                          (change)="setValue($event, 'job_status', 'view')" />
                        <label class="custom-control-label" for="customCheck19"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck20"
                          formControlName="edit"
                          (change)="setValue($event, 'job_status', 'edit')" />
                        <label class="custom-control-label" for="customCheck20"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="owner_info">
                    <td>
                      <span class="text-black">Owner Info</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck17"
                          formControlName="view"
                          (change)="setValue($event, 'owner_info', 'view')" />
                        <label class="custom-control-label" for="customCheck17"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck18"
                          formControlName="edit"
                          (change)="setValue($event, 'owner_info', 'edit')" />
                        <label class="custom-control-label" for="customCheck18"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="customers">
                    <td>
                      <span class="text-black">Customers</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck61"
                          formControlName="view"
                          (change)="setValue($event, 'customers', 'view')" />
                        <label class="custom-control-label" for="customCheck61"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck62"
                          formControlName="edit"
                          (change)="setValue($event, 'customers', 'edit')" />
                        <label class="custom-control-label" for="customCheck62"></label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Jobs End-->
            <!-- JobPointe -->
            <div class="tab-pane fade" id="job-pointe" role="tabpanel" formGroupName="permissions">
              <table class="texupp" width="100%">
                <tbody>
                  <tr>
                    <td></td>
                    <th>View</th>
                    <th>Edit</th>
                  </tr>
                  <tr class="permissions_form" formGroupName="job_pointe">
                    <td class="text-black">Job Pointe</td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="job_pointe_view"
                          formControlName="view"
                          (change)="setValue($event, 'job_pointe', 'view')" />
                        <label class="custom-control-label" for="job_pointe_view"></label>
                      </div>
                    </td>
                    <td></td>
                  </tr>
                  <tr class="permissions_form" formGroupName="job_board_attributes">
                    <td>
                      <span class="text-black pl-3">Job Board</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="job_board_attributes_view"
                          formControlName="view"
                          (change)="setValue($event, 'job_board_attributes', 'view')" />
                        <label class="custom-control-label" for="job_board_attributes_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="job_board_attributes_edit"
                          formControlName="edit"
                          (change)="setValue($event, 'job_board_attributes', 'edit')" />
                        <label class="custom-control-label" for="job_board_attributes_edit"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="manage_jobs">
                    <td>
                      <span class="text-black pl-3">Manage Jobs</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="manage_jobs_view"
                          formControlName="view"
                          (change)="setValue($event, 'manage_jobs', 'view')" />
                        <label class="custom-control-label" for="manage_jobs_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="manage_jobs_edit"
                          formControlName="edit"
                          (change)="setValue($event, 'manage_jobs', 'edit')" />
                        <label class="custom-control-label" for="manage_jobs_edit"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="job_pointe_employees">
                    <td>
                      <span class="text-black pl-3">Employees</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="job_pointe_employees_view"
                          formControlName="view"
                          (change)="setValue($event, 'job_pointe_employees', 'view')" />
                        <label class="custom-control-label" for="job_pointe_employees_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="job_pointe_employees_edit"
                          formControlName="edit"
                          (change)="setValue($event, 'job_pointe_employees', 'edit')" />
                        <label class="custom-control-label" for="job_pointe_employees_edit"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="job_pointe_configuration">
                    <td>
                      <span class="text-black pl-3">Configuration</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="job_pointe_configuration_view"
                          formControlName="view"
                          (change)="setValue($event, 'job_pointe_configuration', 'view')" />
                        <label class="custom-control-label" for="job_pointe_configuration_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="job_pointe_configuration_edit"
                          formControlName="edit"
                          (change)="setValue($event, 'job_pointe_configuration', 'edit')" />
                        <label class="custom-control-label" for="job_pointe_configuration_edit"></label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- JobPointe End -->

            <!-- ToolPointe -->
            <div class="tab-pane fade" id="tool-pointe" role="tabpanel" formGroupName="permissions">
              <table class="texupp" width="100%">
                <tbody>
                  <tr>
                    <td></td>
                    <th>View</th>
                    <th>Detailed View</th>
                    <th>Edit</th>
                    <th>Admin</th>
                  </tr>
                  <tr class="permissions_form" formGroupName="tools">
                    <td>
                      <span class="text-black">Tools</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tools_view"
                          formControlName="view"
                          (change)="setValue($event, 'tools', 'view')" />
                        <label class="custom-control-label" for="tools_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tools_detailed_view"
                          formControlName="detailed_view"
                          (change)="setValue($event, 'tools', 'detailed_view')" />
                        <label class="custom-control-label" for="tools_detailed_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tools_edit"
                          formControlName="edit"
                          (change)="setValue($event, 'tools', 'edit')" />
                        <label class="custom-control-label" for="tools_edit"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tools_admin"
                          formControlName="admin"
                          (change)="setValue($event, 'tools', 'admin')" />
                        <label class="custom-control-label" for="tools_admin"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="tools_history">
                    <td>
                      <span class="text-black">Tool History</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tool_history_view"
                          formControlName="view"
                          (change)="setValue($event, 'tools_history', 'view')" />
                        <label class="custom-control-label" for="tool_history_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tool_history_detailed_view"
                          formControlName="detailed_view"
                          (change)="setValue($event, 'tools_history', 'detailed_view')" />
                        <label class="custom-control-label" for="tool_history_detailed_view"></label>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr class="permissions_form" formGroupName="tool_inventory">
                    <td>
                      <span class="text-black">Tool Inventory</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tool_inventory_view"
                          formControlName="view"
                          (change)="setValue($event, 'tool_inventory', 'view')" />
                        <label class="custom-control-label" for="tool_inventory_view"></label>
                      </div>
                    </td>
                    <td></td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tool_inventory_edit"
                          formControlName="edit"
                          (change)="setValue($event, 'tool_inventory', 'edit')" />
                        <label class="custom-control-label" for="tool_inventory_edit"></label>
                      </div>
                    </td>
                    <td></td>
                  </tr>
                  <tr class="permissions_form" formGroupName="tool_models">
                    <td>
                      <span class="text-black">Tool Models</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tool_models_view"
                          formControlName="view"
                          (change)="setValue($event, 'tool_models', 'view')" />
                        <label class="custom-control-label" for="tool_models_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tool_models_detailed_view"
                          formControlName="detailed_view"
                          (change)="setValue($event, 'tool_models', 'detailed_view')" />
                        <label class="custom-control-label" for="tool_models_detailed_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tool_models_edit"
                          formControlName="edit"
                          (change)="setValue($event, 'tool_models', 'edit')" />
                        <label class="custom-control-label" for="tool_models_edit"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="tool_models_admin"
                          formControlName="admin"
                          (change)="setValue($event, 'tool_models', 'admin')" />
                        <label class="custom-control-label" for="tool_models_admin"></label>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-black">Asset Classes</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr
                    class="permissions_form"
                    *ngFor="let assetClass of getAssetClasses() | keyvalue"
                    formGroupName="asset_class">
                    <td>
                      <span class="text-black pl-3"> {{ assetClass.key }}</span>
                    </td>
                    <td [formGroupName]="assetClass.key">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="asset_class_view_{{ assetClass.key }}"
                          formControlName="view"
                          (change)="setAssetClassValue($event, assetClass.key, 'view')" />
                        <label class="custom-control-label" for="asset_class_view_{{ assetClass.key }}"></label>
                      </div>
                    </td>
                    <td [formGroupName]="assetClass.key">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="asset_class_detailed_view_{{ assetClass.key }}"
                          formControlName="detailed_view"
                          (change)="setAssetClassValue($event, assetClass.key, 'detailed_view')" />
                        <label
                          class="custom-control-label"
                          for="asset_class_detailed_view_{{ assetClass.key }}"></label>
                      </div>
                    </td>
                    <td [formGroupName]="assetClass.key">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="asset_class_edit_{{ assetClass.key }}"
                          formControlName="edit"
                          (change)="setAssetClassValue($event, assetClass.key, 'edit')" />
                        <label class="custom-control-label" for="asset_class_edit_{{ assetClass.key }}"></label>
                      </div>
                    </td>
                    <td [formGroupName]="assetClass.key">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="asset_class_admin_{{ assetClass.key }}"
                          formControlName="admin"
                          (change)="setAssetClassValue($event, assetClass.key, 'admin')" />
                        <label class="custom-control-label" for="asset_class_admin_{{ assetClass.key }}"></label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- ToolPointe End -->

            <!-- Purchase Orders-->
            <div class="tab-pane fade" id="purchase-orders" role="tabpanel" formGroupName="permissions">
              <table class="texupp" width="100%">
                <tbody>
                  <tr>
                    <td></td>
                    <th>View</th>
                    <th>Edit</th>
                  </tr>
                  <tr class="permissions_form" formGroupName="purchase_orders">
                    <td>
                      <span class="text-black">Purchase Orders</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="purchase_orders_view"
                          formControlName="view"
                          (change)="setValue($event, 'purchase_orders', 'view')" />
                        <label class="custom-control-label" for="purchase_orders_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="purchase_orders_edit"
                          formControlName="edit"
                          (change)="setValue($event, 'purchase_orders', 'edit')" />
                        <label class="custom-control-label" for="purchase_orders_edit"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="po_amount">
                    <td>
                      <span class="text-black pl-3">PO Amount</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck21"
                          formControlName="view"
                          (change)="setValue($event, 'po_amount', 'view')" />
                        <label class="custom-control-label" for="customCheck21"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck22"
                          formControlName="edit"
                          (change)="setValue($event, 'po_amount', 'edit')" />
                        <label class="custom-control-label" for="customCheck22"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="material_request">
                    <td>
                      <span class="text-black">Material Request</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck23"
                          formControlName="view"
                          (change)="setValue($event, 'material_request', 'view')" />
                        <label class="custom-control-label" for="customCheck23"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck24"
                          formControlName="edit"
                          (change)="setValue($event, 'material_request', 'edit')" />
                        <label class="custom-control-label" for="customCheck24"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="receiving">
                    <td>
                      <span class="text-black">Receiving</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="receiving_view"
                          formControlName="view"
                          (change)="setValue($event, 'receiving', 'view')" />
                        <label class="custom-control-label" for="receiving_view"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="receiving_edit"
                          formControlName="edit"
                          (change)="setValue($event, 'receiving', 'edit')" />
                        <label class="custom-control-label" for="receiving_edit"></label>
                      </div>
                    </td>
                  </tr>
                     <tr class="permissions_form" formGroupName="receiving_module_po_update_notify_owner">
                    <td>
                      <span class="text-black">PO Notifications</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="receiving_module_po_update_notify_owner_view"
                          formControlName="view"
                          (change)="setValue($event, 'receiving_module_po_update_notify_owner', 'view')" />
                        <label class="custom-control-label" for="receiving_module_po_update_notify_owner_view"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="accounting">
                    <td>
                      <span class="text-black">Accounting</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck25"
                          formControlName="view"
                          (change)="setValue($event, 'accounting', 'view')" />
                        <label class="custom-control-label" for="customCheck25"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck26"
                          formControlName="edit"
                          (change)="setValue($event, 'accounting', 'edit')" />
                        <label class="custom-control-label" for="customCheck26"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="sage_export">
                    <td>
                      <span class="text-black pl-3">Sage Export</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck27"
                          formControlName="view"
                          (change)="setValue($event, 'sage_export', 'view')" />
                        <label class="custom-control-label" for="customCheck27"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck28"
                          formControlName="edit"
                          (change)="setValue($event, 'sage_export', 'edit')" />
                        <label class="custom-control-label" for="customCheck28"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="jobs">
                    <td>
                      <span class="text-black">Jobs</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="jobsChk1"
                          formControlName="view"
                          (change)="setValue($event, 'jobs', 'view')" />
                        <label class="custom-control-label" for="jobsChk1"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="jobsChk2"
                          formControlName="edit"
                          (change)="setValue($event, 'jobs', 'edit')" />
                        <label class="custom-control-label" for="jobsChk2"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="vendors">
                    <td>
                      <span class="text-black">Vendors</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck29"
                          formControlName="view"
                          (change)="setValue($event, 'vendors', 'view')" />
                        <label class="custom-control-label" for="customCheck29"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck30"
                          formControlName="edit"
                          (change)="setValue($event, 'vendors', 'edit')" />
                        <label class="custom-control-label" for="customCheck30"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="master_list">
                    <td>
                      <span class="text-black">Master List</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="masterList1"
                          formControlName="view"
                          (change)="setValue($event, 'master_list', 'view')" />
                        <label class="custom-control-label" for="masterList1"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="masterList2"
                          formControlName="edit"
                          (change)="setValue($event, 'master_list', 'edit')" />
                        <label class="custom-control-label" for="masterList2"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="settings">
                    <td>
                      <span class="text-black">Settings</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="settings1"
                          formControlName="view"
                          (change)="setValue($event, 'settings', 'view')" />
                        <label class="custom-control-label" for="settings1"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="settings2"
                          formControlName="edit"
                          (change)="setValue($event, 'settings', 'edit')" />
                        <label class="custom-control-label" for="settings2"></label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Purchase Orders End -->
            <!-- Scheduling-->
            <div class="tab-pane fade" id="scheduling" role="tabpanel"></div>
            <!-- Scheduling End -->
            <!-- Safety -->
            <div class="tab-pane fade" id="safety" role="tabpanel"></div>
            <!-- Safety End -->
            <!-- Communication -->
            <div class="tab-pane fade" id="communication" role="tabpanel"></div>
            <!-- Communication End -->
            <!-- Employees -->
            <div class="tab-pane fade" id="employees" role="tabpanel"></div>
            <!-- Employees End -->
            <!-- Settings -->
            <div class="tab-pane fade" id="settings" formGroupName="permissions" role="tabpanel">
              <table class="texupp" width="100%">
                <tbody>
                  <tr>
                    <td></td>
                    <th>View</th>
                    <th>Edit</th>
                  </tr>
                  <tr class="permissions_form" formGroupName="roles_setting">
                    <td>
                      <span class="text-black">Roles</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input p_view"
                          id="customCheck51"
                          formControlName="view"
                          (change)="setValue($event, 'roles_setting', 'view')" />
                        <label class="custom-control-label" for="customCheck51"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input p_edit"
                          id="customCheck52"
                          formControlName="edit"
                          (change)="setValue($event, 'roles_setting', 'edit')" />
                        <label class="custom-control-label" for="customCheck52"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="system_users_setting">
                    <td>
                      <span class="text-black">System User</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck53"
                          formControlName="view"
                          (change)="setValue($event, 'system_users_setting', 'view')" />
                        <label class="custom-control-label" for="customCheck53"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck54"
                          formControlName="edit"
                          (change)="setValue($event, 'system_users_setting', 'edit')" />
                        <label class="custom-control-label" for="customCheck54"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="union_locals_setting">
                    <td>
                      <span class="text-black">Union Locals</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck55"
                          formControlName="view"
                          (change)="setValue($event, 'union_locals_setting', 'view')" />
                        <label class="custom-control-label" for="customCheck55"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck56"
                          formControlName="edit"
                          (change)="setValue($event, 'union_locals_setting', 'edit')" />
                        <label class="custom-control-label" for="customCheck56"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="tools_setting">
                    <td>
                      <span class="text-black">Tool Setting</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck155"
                          formControlName="view"
                          (change)="setValue($event, 'tools_setting', 'view')" />
                        <label class="custom-control-label" for="customCheck155"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck156"
                          formControlName="edit"
                          (change)="setValue($event, 'tools_setting', 'edit')" />
                        <label class="custom-control-label" for="customCheck156"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="design_setting">
                    <td>
                      <span class="text-black">Design</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck57"
                          formControlName="view"
                          (change)="setValue($event, 'design_setting', 'view')" />
                        <label class="custom-control-label" for="customCheck57"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck58"
                          formControlName="edit"
                          (change)="setValue($event, 'design_setting', 'edit')" />
                        <label class="custom-control-label" for="customCheck58"></label>
                      </div>
                    </td>
                  </tr>
                  <tr class="permissions_form" formGroupName="smtp_setting">
                    <td>
                      <span class="text-black">SMTP</span>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck59"
                          formControlName="view"
                          (change)="setValue($event, 'smtp_setting', 'view')" />
                        <label class="custom-control-label" for="customCheck59"></label>
                      </div>
                    </td>
                    <td>
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck60"
                          formControlName="edit"
                          (change)="setValue($event, 'smtp_setting', 'edit')" />
                        <label class="custom-control-label" for="customCheck60"></label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Settings End -->
          </div>
        </div>
        <div class="modal-footer">
          <input type="submit" class="btn btn-primary mb-3 button-eh" value="Save" />
          <button type="button" class="btn btn-primary mb-3 button-eh" #closebutton data-dismiss="modal">Close</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Delete Role Modal -->
<div class="modal fade" id="delete-role" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content pb-0">
      <form action="#">
        <div class="modal-header border-0">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body pb-0 pt-0">
          <div class="notification-text text-center">
            <h4 class="font-weight-normal">
              <b>{{ roleNames[deleteRoleId] }}</b
              ><br />
              Are you sure you would like to delete this role?
            </h4>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <button type="button" class="btn btn-outline-primary width-fix" #closebutton1 data-dismiss="modal">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary width-fix" (click)="deletePermission(deleteRoleId)">
            Delete Role
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Delete Role Modal End-->
